import ApiService from "@/core/services/ApiService";
import axios, { AxiosError } from "axios";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { BackendError } from "../models";

// Interfaz para el mapeo de la base de datos de configuraciones del home
interface ConfigItem {
  key: string;
  value: string;
}

// Interfaz para las FAQs
interface FaqItem {
  pregunta: string;
  respuesta: string;
}

@Module({ namespaced: true, name: "HomeModule" })
export class HomeModule extends VuexModule {
  errors: BackendError | null = null;

  headerImage = "";
  introHtml = "";
  pdfResumen = "";
  pdfResumenName = "";
  pdfPrograma = "";
  pdfProgramaName = "";
  faqsCursos: FaqItem[] = [];
  faqsIam: FaqItem[] = [];

  @Action
  fetchConfig() {
    const url = "/home-configurations";

    return ApiService.get(url)
      .then(({ data }: { data: ConfigItem[] }) => {
        this.setConfigData(data);
      })
      .catch((err: Error | AxiosError) => {
        this.handleError(err);
      });
  }

  @Action
  updateConfig(payload: ConfigItem[]) {
    const url = "/home-configurations/batch";

    return ApiService.post(url, { configurations: payload }).catch(
      (err: Error | AxiosError) => {
        this.handleError(err);
      }
    );
  }

  @Mutation
  setConfigData(data: ConfigItem[]) {
    const img = data.find((c) => c.key === "home_header_image");
    if (img) this.headerImage = img.value;

    const intro = data.find((c) => c.key === "home_intro_html");
    if (intro) this.introHtml = intro.value;

    // Procesamos PDF Resumen (intentando parsear JSON)
    const pdfResumen = data.find((c) => c.key === "home_pdf_resumen");
    if (pdfResumen) {
      try {
        const parsed = JSON.parse(pdfResumen.value);
        this.pdfResumen = parsed.url || "";
        this.pdfResumenName = parsed.name || "";
      } catch (e) {
        // Fallback si antes estaba guardado como un string plano (URL)
        this.pdfResumen = pdfResumen.value || "";
        this.pdfResumenName = "";
      }
    }

    // Procesamos PDF Programa (intentando parsear JSON)
    const pdfPrograma = data.find((c) => c.key === "home_pdf_programa");
    if (pdfPrograma) {
      try {
        const parsed = JSON.parse(pdfPrograma.value);
        this.pdfPrograma = parsed.url || "";
        this.pdfProgramaName = parsed.name || "";
      } catch (e) {
        this.pdfPrograma = pdfPrograma.value || "";
        this.pdfProgramaName = "";
      }
    }

    const fCursos = data.find((c) => c.key === "home_faqs_cursos");
    if (fCursos) {
      try {
        this.faqsCursos = JSON.parse(fCursos.value || "[]");
      } catch (e) {
        this.faqsCursos = [];
      }
    }

    const fIam = data.find((c) => c.key === "home_faqs_iam");
    if (fIam) {
      try {
        this.faqsIam = JSON.parse(fIam.value || "[]");
      } catch (e) {
        this.faqsIam = [];
      }
    }
  }

  @Mutation
  setError(error: BackendError | null) {
    this.errors = error;
  }

  @Action
  private handleError(err: Error | AxiosError) {
    if (axios.isAxiosError(err)) {
      this.context.commit("setError", err.response?.data || { error: err });
    } else {
      this.context.commit("setError", { error: err });
    }
  }
}
